import React, { useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import ExitToApp from "@mui/icons-material/ExitToApp";

// core components
import { Stack, Avatar, Grid, Button } from "@mui/material";

import PopupLogout from "views/dialog/PopupLogout";

import mujerAvatar from "assets/img/undraw_mujer.png";
import hombreAvatar from "assets/img/undraw_hombre.png";

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const classes = useStyles();
  const [popupLogout, setpopupLogout] = React.useState(false);

  const { UserAuth } = useContext(UrlServicesContext);

  const picture =
    UserAuth.avatar === null
      ? UserAuth.gender === 1
        ? hombreAvatar
        : mujerAvatar
      : UserAuth.avatar;

  const handleOpenpopupLogout = () => {
    setpopupLogout(true);
  };

  const handleClosepopupLogout = () => {
    setpopupLogout(false);
  };

  return (
    <div className={classes.manager}>
      <Grid container style={{ float: "right" }}>
        <Grid xs={12} md={12}>
          <Stack direction="row" spacing={2}>
            <Avatar
              src={picture}
              style={{ marginTop: 10, width: 40, height: 40 }}
            />
            <div style={{ marginTop: 10, fontSize: 10 }}>
              <b>
                {UserAuth.allname}
                <div style={{ marginTop: "-8px", color: "gray" }}>
                  {UserAuth.profile_name}
                </div>
              </b>
            </div>
            <Button aria-haspopup="true" onClick={handleOpenpopupLogout}>
              <ExitToApp
                style={{
                  fontSize: 22,
                  color: "#000",
                  marginLeft: "-40px",
                  marginTop: 10,
                }}
              />
            </Button>
          </Stack>
        </Grid>
      </Grid>
      {popupLogout ? (
        <PopupLogout open={popupLogout} exit={handleClosepopupLogout} />
      ) : (
        ""
      )}
    </div>
  );
}
